import avatar from './dhalia/dhalia-avatar.webp';
import hero from './dhalia/dhalia-hero.webp';
import retrato from './dhalia/dhalia-retrato.webp';

/**
 * La cara de DHALIA — desde el 2026-08-07, la ilustración NUEVA que entregó la
 * usuaria (`avatar.png`, 1128×1394, la asistente con el uniforme GrupoDH y el
 * parche «Hecho en Venezuela»), en dos derivados webp del MISMO original:
 * 88×88 para el botón flotante (slot h-11 w-11 = 44 px CSS, ×2 retina) y
 * 72×72 para la cabecera del panel (slot h-9 w-9 = 36 px CSS, ×2 retina).
 * Recorte cuadrado 1128×1128 desde y=40 —centra la cara para el círculo de
 * `rounded-full` + `object-cover`— y reescalado en dos pasos vía canvas
 * (calidad 0,90; en esta máquina no hay sharp/magick/cwebp).
 *
 * Sustituyen a las dos imágenes extraídas del monolito (avatar 6.600 B /
 * hero 19.052 B, SHA-1 en `04_DOCS/ESTADO_DHALIA.md` §3) — aquellas eran DOS
 * artes distintos; ahora son dos tamaños del mismo, que es lo que se pidió.
 * El original queda fuera del repo (CODE/03_MODULOS_HTML/avatar.png, 1,6 MB,
 * la mayoría metadatos C2PA que el re-encode elimina).
 *
 * Aquí son archivos y no base64, por lo mismo que las de Marcas: pasan por el
 * bundler, se emiten en `/assets` con hash y entran en la regla de caché
 * inmutable de `netlify.toml`. Inlinearlas metería base64 en el bundle
 * principal —el que carga TODA página del portal— para pintar un botón.
 *
 * OJO — no moverlas a `public/`: es la trampa del gotcha 20, la misma que ya
 * mordió con `public/marcas/bbk.jpg` contra la ruta `/marcas/:marcaId`.
 */
export const AVATAR_DHALIA = avatar;
export const HERO_DHALIA = hero;

/**
 * El retrato GRANDE (2026-10-26) para la ventana de pendientes que DHALIA
 * enseña al entrar (`componentes/PendientesDhalia.tsx`): 288×288 (slot de 144
 * px CSS ×2), del MISMO original, recorte cuadrado desde y=60 para que entre el
 * hombro con el logo. Hecho con PIL (webp, calidad 86): 14.626 B.
 */
export const RETRATO_DHALIA = retrato;
